var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.17 22.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1071.59,227.73l-.54-1.24a18.5,18.5,0,0,0-8.11,4.17l1.34.83a16.65,16.65,0,0,1,7.31-3.76",
    transform: "translate(-1062.94 -226.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1087.77,231.49l1.34-.83a18.5,18.5,0,0,0-8.11-4.17l-.54,1.24a16.65,16.65,0,0,1,7.31,3.76",
    transform: "translate(-1062.94 -226.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.36,238.31c0-4.42,4.78-8,10.66-8s10.67,3.6,10.67,8-4.78,8-10.67,8-10.66-3.6-10.66-8m23.07,0c0-5.15-5.56-9.32-12.41-9.32s-12.4,4.17-12.4,9.32c0,2.94,1.81,5.57,4.65,7.27l-1.44,2c-.23.32-.07.71.36.88a1,1,0,0,0,.4.08.94.94,0,0,0,.77-.35l1.34-1.91a16,16,0,0,0,12.64,0l1.34,1.91a1,1,0,0,0,.77.35,1,1,0,0,0,.41-.08c.42-.17.59-.56.36-.88l-1.44-2c2.83-1.7,4.65-4.33,4.65-7.27",
    transform: "translate(-1062.94 -226.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1076,232.77h0c-.48,0-.87.29-.87.65l0,4.55-3.24,1.62a.57.57,0,0,0-.24.91,1,1,0,0,0,.73.29,1.16,1.16,0,0,0,.48-.11l3.59-1.79a.91.91,0,0,0,.16-.11.59.59,0,0,0,.26-.47l0-4.88a.79.79,0,0,0-.87-.66",
    transform: "translate(-1062.94 -226.49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.7d0a219e.svg";
export { ForwardRef as ReactComponent };